import { default as ModuleContext } from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { ModalWrapper } from 'components/ModalWrapper';
import { useForceRender } from 'hooks/useForceRender';
import CompoundModel, { ICompound } from 'models/CompoundModel';
import CompoundSearch from 'modules/compounds/CompoundSearch';
import React, { useMemo } from 'react';
import { IGridData } from 'types/models';

type IProps = {
  onClose: () => void;
  onChooseCompound: (data: ICompound) => void;
  courseId?: number | null;
};

const CompoundSearchModal: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();

  const compoundModel = useMemo(() => new CompoundModel({ render: forceRender, courseId: props.courseId || 0 }), [
    forceRender,
    props.courseId,
  ]);

  const handleRowClick = (data: IGridData) => {
    props.onChooseCompound(data as ICompound);
  };

  return (
    <ModalWrapper title="Search Compounds" width={600} height={555} onClose={props.onClose}>
      <ModuleContext.Provider value={compoundModel}>
        <CompoundSearch />
        <Grid handleRowClick={handleRowClick} />
      </ModuleContext.Provider>
    </ModalWrapper>
  );
};

export default CompoundSearchModal;
